const styles = {
  button: {
    height: 50,
    width: 200,
    background: "green",
    borderLeft: "2px solid black",
  },
};
